<template>
  <global-spinner v-if="GlobalLoading"/>
  <enb-msg/>
  <div class='MyStore' @scroll="run"
  ref="mystore"
  :style="{
    fontFamily: Prefes.global.font,
    backgroundColor: Prefes.lojaCorFundo.corBackground
  }"
  >
    <enb-modal v-if="EnbModal.active"/>
    <component v-if="Modal01.active" :is="Theme.modal"/>
    <component v-if="ShowCheckout" :is="Theme.checkout"/>
    <component v-if="ShowSearch01" :is="Theme.search"/>
    <component :is="!Prefes.componentNave || Empresa.modelo === 'Modelo 03' ? Theme.nave : Prefes.componentNave.name"/>
    <side-nave-mobi v-if="SideNave"/>
    <enb-nave-mobi/>
    <enb-content id="content" :data="{ scroll }"/>
    <side-bottom/>
    <component :is="Theme.footer"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EnbContent from '@/components/EnbContent'
import { CheckoutSide01, SearchCont01, EnbModal01, EnbFooter01 } from './Theme01'
import { EnbNave03, EnbModal03, EnbFooter03 } from './Theme03'
import Mobile from '@/components/Mobile'
import EnbMsg from '@/components/EnbMsg/EnbMsg'
import EnbModal from '@/components/EnbPainel/Modal/EnbModal'
import GlobalSpinner from '@/components/Spinner/GlobalSpinner'
import SubDomainReserved from './SubDomainReserved'
import Naves from '../components/Naves'
import api from '@/mixins/api'
export default {
  name: 'MyStore',
  components: { 
    EnbContent,
    CheckoutSide01,
    EnbModal01,
    SearchCont01,
    EnbFooter01,
    EnbMsg,
    EnbNave03,
    EnbModal03,
    EnbFooter03,
    EnbModal,
    GlobalSpinner,
    ...Mobile,
    ...Naves
  },
  mixins: [api],
  computed: {
    ...mapGetters(['ShowCheckout', 'ShowSearch01', 'Modal01', 'Theme', 'Prefes', 'Empresa', 'SideNave', 'EnbModal', 'GlobalLoading'])
  },
  methods: {
    run (e) {
      this.scroll = {
        position: e.target.offsetHeight + e.target.scrollTop,
        height: e.target.scrollHeight
      }
    }
  },
  data () {
    return {
      scroll: {
        position: 0,
        height: 1
      }
    }
  },
  created () {
    if(!this.Empresa.nome_empresa) {
      if(SubDomainReserved(window.location.href, this.$router)) {
        return
      }
      this.$router.push('/inicio')
    }
    const existingFavicon = document.querySelector("link[rel*='icon']")
    if (existingFavicon) {
      existingFavicon.remove()
    }
    const newFavicon = document.createElement('link')
    newFavicon.rel = 'icon'
    newFavicon.href = this.api + this.Prefes.favicon.img
    newFavicon.type = 'image/x-icon'
    document.head.appendChild(newFavicon)
  },
  watch: {
    $route (newValue) {
      if(newValue.name === 'Produto' || newValue.name === 'Categoria Produto') {
        this.$refs.mystore.scrollTop = 0
      }
    }
  }
}
</script>

<style scoped>
.MyStore {
  width: 100%;
  height: 100%;
  overflow: auto;
}

/* @media (max-width: 500px) {
  .MyStore {
    overflow: hidden;
  }
} */
</style>
